export default __webpack_public_path__ + "static/media/Indore-Sarafa-Bazaar.a3b6efb5.jpg";